import { fetchDataAndProceed } from '../../config/utils';
import { METHOD_TYPES } from '../../config/constants';

export const getAllFeedback = (data, callback) => {
    return fetchDataAndProceed('/admin/v1/analytics/feedbacks', METHOD_TYPES.GET, data, callback);
};


// WEBPACK FOOTER //
// ./src/data/redux/feedback_details/api.js